var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.686,
    height: 17.686,
    viewBox: "0 0 17.686 17.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35496",
    "data-name": "Group 35496",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63868",
    "data-name": "Path 63868",
    d: "M13.843,5a8.843,8.843,0,1,0,8.843,8.843A8.854,8.854,0,0,0,13.843,5Zm3.343,9.432H14.432v2.753a.59.59,0,1,1-1.179,0V14.432H10.5a.59.59,0,1,1,0-1.179h2.753V10.5a.59.59,0,1,1,1.179,0v2.753h2.753a.59.59,0,1,1,0,1.179Z",
    transform: "translate(-5 -5)",
    fill: "#2580ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a036ffd10e5f5f5124a63a1687649af5.svg";
export { ForwardRef as ReactComponent };